import { defineStore } from "pinia"
import { ref, watch } from "vue"

export const useUIStore = defineStore("ui", () => {
	const isDrawerOpen = ref(true)

	const isSidenavLocked = ref(sessionStorage.getItem("sidenav-locked") === "true")

	watch(isSidenavLocked, value => {
		sessionStorage.setItem("sidenav-locked", String(value))
	})

	const toggleDrawer = () => {
		isDrawerOpen.value = !isDrawerOpen.value
	}

	const openDrawer = () => {
		isDrawerOpen.value = true
	}

	const closeDrawer = () => {
		isDrawerOpen.value = false
	}

	const toggleSidenavLocked = () => {
		isSidenavLocked.value = !isSidenavLocked.value
	}

	return {
		isDrawerOpen,
		isSidenavLocked,
		toggleDrawer,
		openDrawer,
		closeDrawer,
		toggleSidenavLocked,
	}
})
